



















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteRecord } from 'vue-router'
import { schoolMgmt, staffMgmt } from '@/router'
import { NoticeController } from '@/services/request.service'
import { getSchoolInfo } from '@/utils/utils'
const defaultLogo = require('@/assets/images/logo.png')

@Component
export default class PCMenu extends Vue {
  public menuKeys: Array<string> = []
  public menuOpenKeys: Array<string> = []
  public subRoutes: any = { schoolMgmt, staffMgmt }
  public newMessage = 0

  public get routes(): Array<any> {
    const router = this.$route as any
    return router.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName)
  }

  public get roleType(): string {
    return this.$store.state.roleType
  }

  public get schoolId(): number {
    return getSchoolInfo().schoolId
  }

  public get menus(): Array<object> {
    return this.subRoutes
  }

  public get rootMenuOpenKeys(): Array<string> {
    return Object.keys(this.subRoutes)
  }

  public get logo(): any {
    return defaultLogo
  }

  @Watch('$route', { immediate: true })
  public onRouteChanged(to: any, from: any) {
    const routes = to.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName)
    const menuKey = routes.filter(route => route.meta.menu)[0]?.name ?? ''
    this.menuOpenKeys = routes[1] ? [routes[0].name] : []
    this.menuKeys = [menuKey]
    this.getMessage()
  }

  public created(): void {
    const routes = this.routes
    this.menuOpenKeys = routes[2]
      ? [routes[1].name, routes[0].name]
      : routes[1]
      ? [routes[0].name]
      : []
    this.menuKeys = routes[2] ? [routes[2].name] : routes[1] ? [routes[1].name] : [routes[0].name]
  }

  public getMessage(): void {
    NoticeController.hasUnreadMessage()
      .then(res => {
        if (res.data.inSchool || res.data.reply) {
          this.newMessage = 1
        } else {
          this.newMessage = 0
        }
      })
      .catch(err => {
        console.warn(err)
      })
  }

  public onOpenChange(openKeys): void {
    const latestOpenKey = openKeys.find(key => this.menuOpenKeys.indexOf(key) === -1)
    if (this.rootMenuOpenKeys.indexOf(latestOpenKey) === -1) {
      this.menuOpenKeys = openKeys
    } else {
      const children = this.subRoutes[latestOpenKey].children
      const childrenArray = children.map(child => child.name)
      this.menuOpenKeys = latestOpenKey ? [latestOpenKey, ...childrenArray] : []
    }
  }

  public clickLeftMenu({ key }: { key: string }): void {
    this.$router.push({ name: key }).catch(err => {})
  }

  public calcType(name): string {
    const nameTypeList = {
      schoolMgmt: 'bank',
      staffMgmt: 'idcard',
    }
    return nameTypeList[name]
  }
}
